import { useEffect, useRef, useState } from "react";
import { getToken, isSupported } from "firebase/messaging";
import { messaging } from "../lib/firebase";
import axiosClient from "../api/axiosClient";

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

export const usePushNotifications = (showToast) => {
  const [permission, setPermission] = useState(
    () => ("Notification" in window ? Notification.permission : "denied")
  );
  const tokenRegistered = useRef(false);

  // One-time token registration when permission is granted
  useEffect(() => {
    if (permission !== "granted" || tokenRegistered.current || !messaging) return;

    tokenRegistered.current = true;

    isSupported().then((supported) => {
      if (!supported) return;
      return getToken(messaging, { vapidKey: VAPID_KEY });
    }).then((token) => {
      if (token) return axiosClient.put("notifications/fcm-token", { fcmToken: token });
    }).catch((error) => {
      console.error("[Push] setup failed:", error);
    });
  }, [permission]);

  // Foreground message listener — always registers/cleans up correctly
  useEffect(() => {
    if (permission !== "granted") return;

    const onSWMessage = (e) => {
      if (e.data?.type !== "PUSH_RECEIVED") return;
      const { title, body } = e.data;
      showToast?.(`${title ? `${title}: ` : ""}${body ?? "New notification"}`, "info");
    };

    navigator.serviceWorker?.addEventListener("message", onSWMessage);
    return () => navigator.serviceWorker?.removeEventListener("message", onSWMessage);
  }, [permission, showToast]);

  const enable = async () => {
    const perm = await Notification.requestPermission();
    setPermission(perm);
  };

  return { enable, permission };
};
